import React, { useState } from 'react';

interface SearchTicketModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (ticketData: any) => void;
    types: any[];
    states: any[];
}

const FilterComponentsModal: React.FC<SearchTicketModalProps> = ({ isVisible, onClose, onSearch, types, states }) => {
    const [selectedType, setSelectedType] = useState('');
    const [selectedState, setSelectedState] = useState('');

    const handleSearchClick = async () => {
        const filters = {
            state: selectedState,
            type: selectedType
        }
        onSearch(filters);
        onClose()
    };

    const handleClearFilters = () => {
        setSelectedType('');
        setSelectedState('');
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">search</span>
                        <p className="buscar-header">FILTRAR</p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">close</span>
                    </div>
                </div>
                <div className="body-filter-ticket">
                    <div className="body-filter-dropdown">
                        <select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">ESTADO</option>
                            {states
                                .filter((option) => option.value !== "")
                                .map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                        </select>
                        <select
                            className="dropdown"
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            <option value="">TIPO</option>
                            {types
                                .filter((option) => option.value !== "")
                                .map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
                <div className="filter-buttons">
                    <button onClick={handleSearchClick} className="filter-search-button">BUSCAR</button>
                    <button onClick={handleClearFilters} className="clear-button">
                        BORRAR FILTROS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterComponentsModal;